import { useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import { post_SubLesson } from "../services/SubLesson";
import { PleasewaitPopup } from "./PleasewaitPopup";

type AddSubLessonProps = {
    showPopup: boolean;
    setShowPopup: (value: boolean) => void;
    setRefreshSubLessonList: (value: boolean) => void;
    selectedLessonId: number | null;
}

export const AddSubLesson = ({ showPopup, setShowPopup, setRefreshSubLessonList, selectedLessonId: selectedLessonIdProp }: AddSubLessonProps) => {
    const { auth }: any = useAuth();
    const [selectedLessonId, setSelectedLessonId] = useState<number | null>(null);
    const [subLessonTitle, setSubLessonTitle] = useState<string>("");
    const [subLessonDiscription, setSubLessonDiscription] = useState<string>("");
    const [showPleasewait, setShowPleasewait] = useState<boolean>(false);

    useEffect(() => {
        if (selectedLessonIdProp) {
            setSelectedLessonId(selectedLessonIdProp);
        }
    }, [selectedLessonIdProp]);

    const handleOnSave = () => {
        console.log(selectedLessonId);
        if (selectedLessonId) {
            setShowPleasewait(true);
            post_SubLesson({
                lessonId: selectedLessonId,
                title: subLessonTitle,
                description: subLessonDiscription,
                orderNumber: 0,
                createdAt: new Date().toLocaleString(),
                createdBy: auth?.givenname
            }, auth?.id)
                .then((res) => {
                    setShowPleasewait(false);
                    setShowPopup(false);
                    setRefreshSubLessonList(true);
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        if (showPopup) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [showPopup]);

    if (!showPopup) return null;

    return (
        <>
            <div className="fixed inset-0 z-[9999999] flex items-center justify-center bg-black/50 p-10">
                <div className="bg-white w-full max-w-3xl rounded-md shadow-lg max-h-[90vh] flex flex-col">

                    <div className="px-6 py-4 border-b w-full flex justify-between items-center">
                        <h2 className="text-lg font-medium">Add sub-lesson</h2>
                        <button
                            onClick={() => {
                                setShowPopup(false)
                            }}
                            className="text-gray-500"
                        >
                            <span className="material-symbols-outlined text-2xl">
                                close
                            </span>
                        </button>
                    </div>


                    <div>
                        <div className="px-6 pt-6 space-y-4">

                            <label className="font-medium">Sub-Lesson Title</label>
                            <input
                                type="text"
                                placeholder="Title"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={subLessonTitle}
                                onChange={(e) => setSubLessonTitle(e.target.value)}
                            />

                        </div>

                        <div className="px-6 py-6 space-y-4">
                            <label className="font-medium">Sub-Lesson Description</label>
                            <textarea
                                rows={3}
                                placeholder="Description"
                                className="w-full mt-2 border rounded px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-primary"
                                value={subLessonDiscription}
                                onChange={(e) => setSubLessonDiscription(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="px-6 py-4 border-t flex justify-end space-x-3">

                        <button
                            className={`px-6 py-2 ${!subLessonTitle ? "bg-gray-300 text-white cursor-not-allowed" : "bg-primary text-white cursor-pointer"}  font-medium rounded`}
                            disabled={!subLessonTitle ? true : false}
                            onClick={handleOnSave}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </div >
            <PleasewaitPopup showPopup={showPleasewait} />
        </>
    )
}